import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconDesc = () => {
  return (
    <ControlSafe>
      <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 2.22211C0 1.24027 0.795938 0.444336 1.77778 0.444336H12.4444C13.4263 0.444336 14.2222 1.24027 14.2222 2.22211V4.88878C14.2222 5.87062 13.4263 6.66656 12.4444 6.66656H1.77778C0.795938 6.66656 0 5.87062 0 4.88878V2.22211Z"
          fill="#646464"
        />
        <path
          d="M0 11.111C0 10.1292 0.795938 9.33322 1.77778 9.33322H12.4444C13.4263 9.33322 14.2222 10.1292 14.2222 11.111V13.7777C14.2222 14.7595 13.4263 15.5554 12.4444 15.5554H1.77778C0.795938 15.5554 0 14.7595 0 13.7777V11.111Z"
          fill="#646464"
        />
        <path
          d="M16.0524 4.88887C16.1067 4.94609 16.1813 4.97973 16.2601 4.98257C16.3447 4.98414 16.426 4.95014 16.4842 4.88887L18.8064 2.56665V7.95261C18.8086 8.12044 18.9441 8.25597 19.112 8.25816C19.2798 8.25597 19.4153 8.12044 19.4175 7.95261V2.56664L21.7398 4.88887C21.8176 4.96892 21.9323 5.00135 22.0406 4.97394C22.1488 4.94653 22.2342 4.86344 22.2646 4.75598C22.295 4.64851 22.2658 4.533 22.1879 4.45294L19.3361 1.60109C19.215 1.48624 19.0252 1.48624 18.9042 1.60109L16.0524 4.45294C15.9939 4.51039 15.9609 4.58893 15.9609 4.67091C15.9609 4.75288 15.9939 4.83142 16.0524 4.88887Z"
          fill="#646464"
          stroke="#646464"
          stroke-width="0.5"
        />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconDesc)
